import {
    CrudMode,
    DataDisplay,
    Grid,
    pn,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { ScholarshipPaymentMethod, ScholarshipPaymentMethodEditResource, ScholarshipPaymentMethodViewResource } from "generated/openApi";
import produce from "immer";

export const ScholarshipPaymentMethodPageBody = (props: {
    scholarshipPaymentMethod: ScholarshipPaymentMethod;
    setScholarshipPaymentMethod(arg0: any): void;
    crudMode: CrudMode;
    viewResource: ScholarshipPaymentMethodViewResource;
    editResource: ScholarshipPaymentMethodEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<ScholarshipPaymentMethod>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.scholarshipPaymentMethod.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.scholarshipPaymentMethod.name}
                onChange={(e) =>
                    props.setScholarshipPaymentMethod(
                        produce(props.scholarshipPaymentMethod, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};
